import React from "react";
import { DialogContext, DialogContextProps } from "../contexts/dialogContext";

export const useDialog = () => {
  const { container, content, setIsOpen, isOpen } =
    React.useContext(DialogContext);

  return {
    container,
    content,
    isOpen: isOpen,
    setIsOpen,
  };
};

export const useInitDialog = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const containerRef: React.RefObject<HTMLDivElement> =
    React.useRef<HTMLDivElement>(null);
  const content: React.RefObject<HTMLDivElement> =
    React.useRef<HTMLDivElement>(null);

  const context: DialogContextProps = React.useMemo(() => {
    return {
      container: containerRef,
      content,
      isOpen,
      setIsOpen,
    };
  }, [isOpen]);

  return context;
};
